/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandExecution extends models.AwsSsmBaseExecution {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmCommandExecution");
    }

    getFixupPrototypeFunction() { return AwsSsmCommandExecution.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandExecution>): AwsSsmCommandExecution {
        let obj = Object.assign(new AwsSsmCommandExecution(), model);
        AwsSsmCommandExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandExecution>): AwsSsmCommandExecution {
        if (!model) return null;
        return AwsSsmCommandExecution.newInstance(<AwsSsmCommandExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandExecution) {
        if (!obj) return;

        models.AwsSsmCommandExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandExecution): boolean {
        if (models.AwsSsmBaseExecution.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmCommandExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.delivery_timeout_seconds === undefined) {
            this.delivery_timeout_seconds = 0;
        }
        if (typeof this.requested_date_time === "string") {
            this.requested_date_time = new Date(<string><any>this.requested_date_time);
        }
        if (typeof this.expires_after === "string") {
            this.expires_after = new Date(<string><any>this.expires_after);
        }
        if (this.notification_config) {
            models.AwsSsmNotificationConfig.fixupPrototype(this.notification_config);
        }
        if (this.cloudwatch_output_config) {
            models.AwsSsmCloudWatchOutputConfig.fixupPrototype(this.cloudwatch_output_config);
        }
        if (this.alarm_configuration) {
            models.AwsSsmDocumentAlarmConfiguration.fixupPrototype(this.alarm_configuration);
        }
    }

    /**
     * User specified information.
     */
    comment: string;

    /**
     * The parameter values to be inserted in the document when running the command
     */
    parameters: { [key: string]: string; };

    /**
     * The date and time the command was requested.
     */
    requested_date_time: Date;

    /**
     * Time after the command expires.
     */
    expires_after: Date;

    /**
     * List of target instance ids.
     */
    instance_ids: Array<string>;

    /**
     * Region of s3 bucket to store output.
     */
    output_s3_region: string;

    /**
     * Name of s3 bucket to store output.
     */
    output_s3_bucket_name: string;

    /**
     * Key prefix of s3 path.
     */
    output_s3_key_prefix: string;

    /**
     * Number of target resources selected.
     */
    target_count: string;

    /**
     * Number of target resources completed
     */
    completed_count: string;

    /**
     * Number of target resources failed
     */
    error_count: string;

    /**
     * Time to wait before failing
     */
    delivery_timed_out_count: string;

    /**
     * Role of the service.
     */
    service_role: string;

    /**
     * Configuration details of the notification.
     */
    notification_config: models.AwsSsmNotificationConfig;

    /**
     * Cloud watch output configuration details
     */
    cloudwatch_output_config: models.AwsSsmCloudWatchOutputConfig;

    /**
     * Delivery Time out in seconds
     */
    delivery_timeout_seconds: number;

    /**
     * Status of the Execution
     */
    status: models.AwsSsmCommandExecutionStatus;

    /**
     * Detailed status of the execution
     */
    status_details: string;

    alarm_configuration: models.AwsSsmDocumentAlarmConfiguration;

}
